/* eslint-disable no-useless-escape */

import React from 'react';
import { cancel } from 'redux-saga/effects';
import Querystring from 'query-string';
import uniqBy from 'lodash/uniqBy';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import isString from 'lodash/isString';
import moment from 'moment';
import { oneWayNotAllow } from 'routeConfig/checkTwoWay';
import packageJson from '../../package.json';
import {
  get,
  isArray,
  isBoolean,
  isEmpty,
  isNumber,
  isObject,
  isPlainObject,
  toString,
} from 'lodash';
import { ITEM_PER_PAGE, pageSize } from 'consts/filters';
import {
  optionFilterHistory,
  statusTickets,
  typeDataTrigger,
  statusHistoryEnum,
  SIZE_ICON,
  LINK_REGEX,
  listCountries,
} from 'consts/data';
import { CommonIcons } from 'components/Icons';
import { enumColumn } from 'models/column-monitoring.model';
import { colorStatusReport } from 'consts/colorChart';
import { localeNumber } from './string';

export const checkPlivoPowerPack = (phoneType = '') => {
  return isEqual('plivo_powerpack', phoneType);
};

export const isNotEmpty = (arg) => !isEmpty(arg);

export const delayTime = (ms = 0) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
};

export const getEnv = () => {
  return process.env.NODE_ENV;
};

export const getVersion = () => (packageJson.version ? `v${packageJson.version}` : '');

export const checkIsLast = (list = [], limit = pageSize) => {
  return list.length < limit;
};

export const getOffset = (el) => {
  let rect = el.getBoundingClientRect();
  let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
};

export const getPathName = (history) => history && history.location.pathname;
export const getQuerySearch = (history) => history && Querystring.parse(history.location.search);
export const contactDetailHadResponder = (groupId, listDialog) =>
  listDialog.some((dialog) => dialog.contactGroupId === groupId);
export const findIdResponder = (groupId, listDialog) =>
  listDialog.find((dialog) => dialog.contactGroupId === groupId)?.id;

export const uniqByKeepLast = (list, key) => {
  return [...new Map(cloneDeep(list).map((x) => [key(x), x])).values()];
};

export const getNextDataRefetch = (
  responseSuccess = [],
  numberIsLast = ITEM_PER_PAGE,
  customFieldData = undefined,
) => {
  const listOfResponseSuccess = isArray(responseSuccess) ? responseSuccess : [];
  const tempArr = listOfResponseSuccess.reduce((arr, el) => {
    if (customFieldData) {
      arr = [...arr, ...get(el?.data || {}, customFieldData)];
    } else {
      arr = [...arr, ...(el?.data || {})];
    }
    return arr;
  }, []);
  let isLast = false;
  if (customFieldData) {
    isLast =
      get(listOfResponseSuccess[listOfResponseSuccess.length - 1]?.data, customFieldData).length <
      numberIsLast;
  } else {
    isLast = listOfResponseSuccess[listOfResponseSuccess.length - 1]?.data?.length < numberIsLast;
  }

  return [tempArr, isLast];
};

/**
 *
 * @param {any[]} list - Any array
 * @param {string} fieldForLabel  - String / Undefined
 * @param {string} fieldForValue - String / Undefined
 * @param {boolean} noneOption - True / False
 * @returns
 */
export const convertToFormSelect = (
  list,
  fieldForLabel = undefined,
  fieldForValue = undefined,
  noneOption = false,
) => {
  if (!fieldForLabel || !fieldForValue) {
    return [
      ...list.reduce((arr, el) => {
        return [...arr, { label: el, value: el }];
      }, []),
    ];
  }
  if (typeof list === 'object' && list) {
    const listReturn = [
      ...list.reduce((arr, el) => {
        return [
          ...arr,
          {
            ...el,
            label: get(el, fieldForLabel) ?? 'None',
            value: get(el, fieldForValue) ?? '',
          },
        ];
      }, []),
    ];

    if (noneOption) {
      return [{ label: 'None', value: '' }, ...listReturn];
    }
    return listReturn;
  }
  return [{ label: 'None', value: '' }, ...list];
};

// Use for Select when value is object
export const getValueFromFormik = (value) => {
  if (typeof value === 'object') return value.value;
  return value;
};

export const isDefine = (arg) => {
  return !!toString(arg);
};

export const isDevEnvironment = () => {
  return !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
};

export const isInvalidField = (touched = {}, errors = {}, field = '') => {
  return touched[field] && !!errors[field];
};

export const removeItemByIndex = (list, index) => {
  return list.reduce((arr, el, idx) => {
    if (idx !== index) {
      arr = [...arr, el];
    }
    return arr;
  }, []);
};

export const checkIsThisAccountLogging = (email, emailOfThisAccount) => {
  return email === emailOfThisAccount;
};

export const isResponseURL = (string) => {
  if (string.includes('/')) return true;
  return false;
};

export const convertTimeStampToDate = (timestamp, format = 'MMMM DD YYYY, h:mm:ss a') =>
  moment.unix(timestamp).format(format);

export const convertAndGetValueStats = (list) => {
  return (
    list &&
    list.reduce((arr, el) => {
      arr = [...arr, el.split(' ')[2]];
      return arr;
    }, [])
  );
};

export const getFileName = (res) => {
  const filename = res.headers['content-disposition'];
  let filenameSplit = filename.split(';')[1];
  filenameSplit = filenameSplit.match(/\"(.*?)\"/g);
  if (filenameSplit) {
    return filenameSplit[0].replace(/\"/g, '');
  }
  return '';
};

export const download = (link) => {
  if (link && typeof link === 'string') {
    const tagA = document.createElement('a');
    tagA.href = link;
    tagA.click();
    tagA.remove();
  } else {
    console.log('Type link must be string!!');
  }
};

export const removeElementNotTrue = (list) =>
  list && typeof list === 'object' && list.filter((el) => el);
export const splitDataByChar = (string, char) => string && string.split(char);

export const filterNavArccodingRole = (navigation, role, twoWay = undefined) => {
  const navFake = cloneDeep(navigation);
  navFake['items'] = navFake.items.reduce((arr, el) => {
    if (twoWay === 1 && oneWayNotAllow.includes(el.name.toLowerCase())) {
      el.class = 'hide-nav';
    }

    if (!el.permission) {
      el.class = 'hide-nav';
    }

    arr = [...arr, el];
    // if (el.permission) {
    //   if (el.permission.includes('All') || el.permission.includes(role)) {
    //     if (oneWayNotAllow.includes(el.name.toLowerCase()) && twoWay === 1) {
    //       el.class = 'hide-nav';
    //       arr = [...arr, el];
    //     } else {
    //       arr = [...arr, el];
    //     }
    //   } else {
    //     el.class = 'hide-nav';
    //     arr = [...arr, el];
    //   }
    // } else arr = [...arr, el];
    return arr;
  }, []);
  return navFake;
};
export const renderWithCondition = (condition, Component) => {
  if (condition) {
    return <Component />;
  }
};
export const renderJSX = (par) => () => par;
export const isResponseSuccess = (status) => status >= 200 && status <= 299;
export const convertCurrency = (string, local) => string.toLocaleString(local);
export const clearCharacter = (string, comma) => string && string.replace(comma, '');

export const convertToFormSelectForSwitchAccount = (list) => {
  if (typeof list === 'object' && list) {
    return list.reduce((arr, el) => {
      return [
        ...arr,
        {
          ...el,
          label: `${el.username}`,
          value: el.username,
        },
      ];
    }, []);
  }
  return list;
};

// For Contact Page
export const mapListBoxWithListContact = (listBox, listContact) => {
  if (typeof listBox === 'object' && typeof listContact === 'object' && listBox && listContact) {
    return listBox.reduce((arr, el, index) => {
      arr = [...arr, el];
      listContact.forEach((el2) => {
        if (
          typeof el2.name === 'string' &&
          typeof el.name === 'string' &&
          el2.name.toLowerCase() === el.name.toLowerCase()
        ) {
          arr[index] = { ...arr[index], number: el2.count, id: el2.id };
        }
      });
      return arr;
    }, []);
  }
  return listBox;
};

// For Responder Page
export const mapListBoxWithListReplies = (listBox, listReplies) => {
  if (typeof listBox === 'object' && typeof listReplies === 'object' && listBox && listReplies) {
    return listBox.reduce((arr, el, index) => {
      arr = [...arr, el];
      listReplies.forEach((el2) => {
        if (
          typeof el2.name === 'string' &&
          typeof el.title === 'string' &&
          el2.name.toLowerCase() === el.title.toLowerCase()
        ) {
          arr[index] = { ...arr[index], ...el2 };
        }
      });
      return arr;
    }, []);
  }
  return listBox;
};

export const decodeTrueFalse = (par) => {
  if (typeof par === 'string') {
    if (par.toLowerCase() === 'true') {
      return true;
    }
    return false;
  }
  return par;
};

export const encodeTrueFalse = (par) => {
  if (typeof par === 'boolean') {
    if (par) {
      return 'true';
    }
    return 'false';
  }
  return par;
};

export const filterInListByField = (list, field, value) => {
  if (list && field && value) {
    return list.find((el) => el[field] === value);
  }
  return;
};

export const checkIsValidURL = (url) => {
  const expression =
    /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
  return expression.test(url);
};

export const numberPage = (length, records_per_page) => Math.ceil(length / records_per_page);

export const isAdmin = (role) => true;

export const convertToGroupSelect = (list) => {
  if (list && typeof list === 'object') {
    const roleGrouped = uniqBy(list, 'role').map((el) => el.role);
    return roleGrouped.reduce((arr, role) => {
      let obj = {};
      obj = {
        ...obj,
        label: role,
        options: convertToFormSelectForSwitchAccount(list.filter((el) => el.role === role)),
      };
      arr = [...arr, obj];
      return arr;
    }, []);
  }
  return [];
};

export const stringifyListPhone = (list) =>
  list &&
  list
    .map((el) => `::${el.phone}`)
    .toString()
    .replace(/,/g, '');

export const getIndex = (list, id) => {
  const index = list.findIndex((el) => el.id === id);
  return index;
};

export const convertListToParamString = (listIds, field) =>
  field && typeof field === 'string'
    ? listIds.toString().replace(/\,+/gm, `&${field}=`)
    : listIds.toString().replace(/\,+/gm, '&ids=');

// Cheat hack to ON unMount and animation when open/close modal/dialog
export const toggleDialog = async (open, setOpen, close, setClose) => {
  setOpen(!open);

  //! If open modal
  if (!open) {
    document.body.classList.add('modal-open');
  }

  setTimeout(() => {
    setClose(!close);
    /**
     * Fix freeze bug - user cannot scroll
     */
    // Check if modal exist, remove class modal-open
    const noModalExist = document.querySelectorAll("body > div[tabindex='-1']").length === 0;
    if (noModalExist) {
      console.log('%cNo modal? =>> remove modal-open', 'color: green');
      document.body.classList.remove('modal-open');
    }
  }, 500);
};

export const numberToPercentage = (number = 0) => {
  if (!number) {
    return '0';
  }
  return (Number(number) * 100).toFixed(2);
};

export const ScrollTopPosition = (position) => {
  window.scrollTo({
    top: position,
    behavior: 'smooth',
  });
};

//* ref or element
export const scrollElementBottom = (ref, behavior = 'smooth') => {
  if (ref && ref.current) {
    ref.current.scrollTo({
      behavior,
      top: ref.current.scrollHeight,
    });
    return;
  }

  ref.scrollTo({
    behavior,
    top: ref.scrollHeight,
  });
};

export const filterTypeOfValueObj = (obj) => {
  if (obj && typeof obj === 'object') {
    let tempObj = {};
    for (let key of Object.keys(obj)) {
      if (typeof obj[key] === 'function') tempObj = { ...tempObj, [key]: obj[key] };
    }
    return tempObj;
  }
  return {};
};

export const matchValueWithSelectOption = (val, options, optional = undefined) => {
  if (optional) {
    return optional(val, options);
  } else if (options && typeof options === 'object') {
    return options.find((el) => el.value === val) || null;
  }
  return {};
};

export const cloneObjectByKeys = (listKeys, obj) => {
  let tempObj = {};
  for (let val of listKeys) {
    tempObj = { ...tempObj, [val]: obj[val] };
  }
  return cloneDeep(tempObj);
};

export const suppressNonNumericInput = (event) => {
  const key = event.which || event.keyCode;
  const ctrl =
    event.ctrlKey || event.metaKey
      ? event.ctrlKey || event.metaKey
      : key === 17 || key === 91
      ? true
      : false;
  // metaKey support for Mac OS

  const keyAllow =
    /[0-9]/g.test(event?.key) ||
    [
      'Backspace',
      'Tab',
      '.',
      'Delete',
      '+',
      '-',
      '=',
      'ArrowDown',
      'ArrowUp',
      'ArrowLeft',
      'ArrowRight',
    ].some((k) => k.toLowerCase() === event?.key?.toLowerCase()) ||
    (ctrl && event?.key.toLowerCase() === 'c') ||
    (ctrl && event?.key.toLowerCase() === 'v') ||
    (ctrl && event?.key.toLowerCase() === 'a');
  const preventKeys = !keyAllow;

  if (preventKeys) {
    event.preventDefault(); // Prevent character input
  }
};

export const suppressNonNumericWith =
  ({
    preventDot = false,
    preventMinus = false,
    preventPlus = false,
    preventEqual = false,
    preventUpDownArrow = false,
  }) =>
  (event) => {
    const key = event.which || event.keyCode;
    const ctrl =
      event.ctrlKey || event.metaKey
        ? event.ctrlKey || event.metaKey
        : key === 17 || key === 91
        ? true
        : false;

    // metaKey support for Mac OS
    const keyAllow =
      /[0-9]/g.test(event?.key) ||
      [
        'Backspace',
        'Tab',
        '.',
        'Delete',
        '+',
        '-',
        '=',
        'ArrowDown',
        'ArrowUp',
        'ArrowLeft',
        'ArrowRight',
      ].some((k) => k.toLowerCase() === event?.key?.toLowerCase()) ||
      (ctrl && event?.key.toLowerCase() === 'c') ||
      (ctrl && event?.key.toLowerCase() === 'v') ||
      (ctrl && event?.key.toLowerCase() === 'a');

    // metaKey support for Mac OS
    const preventKeys = !keyAllow;
    if (
      preventKeys ||
      (preventMinus && event?.key === '-') ||
      (preventDot && event?.key === '.') ||
      (preventEqual && event?.key === '=') ||
      (preventPlus && event?.key === '+') ||
      (preventUpDownArrow && (event?.key === 'ArrowUp' || event?.key === 'ArrowDown')) // Up / Down
    ) {
      //* Prevent all keyboard
      event.preventDefault();
    }
  };

export const suppressNonDotInput = (event) => {
  if (event.keyCode === 190) event.preventDefault();
};

export const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const checkTypeValue = (val, type) => typeof val === type;

export const printGender = (gender) => {
  if (gender === 'f') return 'Female';
  return 'Male';
};

export const trimListString = (list) => {
  // If all element is string type
  if (list.every((el) => typeof el === 'string')) {
    return list.map((el) => el.trim());
  }
  if (list.every((el) => typeof el === 'undefined')) {
    return list.map(() => '');
  }
  return list;
};

export const hasDuplicateItem = (list) => {
  return (
    list &&
    typeof list === 'object' &&
    list.filter((el, index) => !isEqual(list.indexOf(el), index)).length > 0
  );
};

export const filterDuplicateItem = (list) => {
  return list.filter((el, index) => !isEqual(list.indexOf(el), index));
};

export const checkIfListIsEmpty = (list) => list.filter((el) => el).length <= 0;

export const IsJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const flattenObject = (ob) => {
  let toReturn = {};

  for (let i in ob) {
    if (!ob.hasOwnProperty(i)) continue;

    if (typeof ob[i] == 'object' && ob[i] !== null) {
      let flatObject = flattenObject(ob[i]);
      for (let x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;

        toReturn[i + '.' + x] = flatObject[x];
      }
    } else {
      toReturn[i] = ob[i];
    }
  }
  return toReturn;
};

export const removeNullOfObject = (obj = {}, conditions = []) => {
  let tempObj = {};
  for (let key of Object.keys(obj)) {
    if (!isEmpty(conditions)) {
      if (!conditions.includes(obj[key])) {
        tempObj[key] = obj[key];
      }
    } else if (obj[key]) {
      tempObj[key] = obj[key];
    }
  }

  return tempObj;
};

export const checkHistoryCompleted = (el) => {
  return toString(el?.status).toLowerCase() === 'completed';
};

export const checkHistoryPaused = (el) => {
  return toString(el?.status).toLocaleLowerCase().includes('paused');
};

export const checkHistoryScheduled = (history) => {
  const status = toString(history?.status).toLowerCase();
  return status.includes(statusHistoryEnum.scheduled) || status.includes('scheduling');
};

export const checkIsAudioFile = (typeFile) => {
  return isString(typeFile) && typeFile.includes('audio/');
};

export const checkHistoryPauseAsDIDNotAvailable = (history) => {
  const status = toString(history?.status).toLowerCase();
  return status === 'Paused_DidNotAvailable'.toLowerCase();
};

//* fileName or fileExtension
export const checkIsImageFile = (fileName) => {
  if (!isString(fileName)) {
    return false;
  }

  const listPrefixFile = [
    '.png',
    '.svg',
    '.webp',
    '.jpg',
    '.jpeg',
    '.jfif',
    '.pjpeg',
    '.pjp',
    '.gif',
  ];
  return listPrefixFile.reduce((result, prefix) => {
    if (`.${fileName}`.includes(prefix)) {
      result = true;
    }

    return result;
  }, false);
};

export const getStatusTicket = (status) => {
  const result = statusTickets.find((el) => el.value === status);
  return {
    label: result?.label || '',
    className: result?.className || '',
  };
};
export function* cancelTask(task) {
  yield cancel(task);
}

export const genPagination = (numberOfPage = 0) => {
  let tempArr = [];
  for (let i = 0; i < numberOfPage; i++) {
    tempArr = [...tempArr, { label: i + 1, value: i + 1 }];
  }

  return tempArr;
};

export const copyToClipboard = (text = '') => {
  const el = document.createElement('textarea');
  el.value = text;
  document.body.appendChild(el);
  el.select();
  el.setSelectionRange(0, 99999);
  navigator.clipboard.writeText(text);
  document.body.removeChild(el);
};

export const filterQueryInHeaderField = (headerField = [], query = {}) => {
  const mapValHeaderField = headerField?.map((el) => el.value);
  let itemInHeaderField = {};
  let itemNotInHeaderField = {};
  Object.keys(query).forEach((key) => {
    //* For case { key: ["value1", "value2", "value3" ]}
    if (isArray(query[key])) {
      let tempArrParams = [];
      (query[key] || []).forEach((val, idx) => {
        if (mapValHeaderField.includes(val)) {
          tempArrParams = [...tempArrParams, val];
        }
      });
      itemInHeaderField[key] = tempArrParams;
    } else if (mapValHeaderField.includes(query[key])) {
      itemInHeaderField[key] = query[key];
    } else {
      itemNotInHeaderField[key] = query[key];
    }
  });

  return { itemInHeaderField, itemNotInHeaderField };
};

export const findValueInOptions = (valueField = '', options = [], nameFieldOfOptions = 'value') => {
  return (
    options?.find((el) =>
      isEqual(
        (valueField || '').toString().toLocaleLowerCase(),
        (el[nameFieldOfOptions] || '').toString().toLocaleLowerCase(),
      ),
    ) || {
      label: '',
      value: '',
    }
  );
};

export const checkIsTabTrigger = (tab) => {
  return typeDataTrigger.map((el) => `${el.value}`).includes(`${tab}`);
};

export const checkStatusBestCampaign = (bestCampaign = {}) => {
  let status = optionFilterHistory[0].value;

  if (checkHistoryCompleted(bestCampaign)) {
    status = optionFilterHistory[1].value;
  }

  if (checkHistoryPaused(bestCampaign)) {
    status = optionFilterHistory[2].value;
  }

  return status;
};

export const cloneAndTransferKey = (obj = {}, arrCompare = []) => {
  const cloneObj = cloneDeep(obj);
  for (let item of arrCompare) {
    const keyOrigin = item[0] || '';
    const keyTransfer = item[1] || '';

    cloneObj[keyTransfer] = cloneObj[keyOrigin];
    delete cloneObj[keyOrigin];
  }

  return cloneObj || {};
};

export const scrollbarWidth = () => {
  // thanks too https://davidwalsh.name/detect-scrollbar-width
  const scrollDiv = document.createElement('div');
  scrollDiv.setAttribute(
    'style',
    'width: 100px; height: 100px; overflow: scroll; position:absolute; top:-9999px;',
  );
  document.body.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
};

export const uniqLastItem = (arr = [], field = 'id') => {
  if (isArray(arr)) {
    const newArr = cloneDeep(arr);
    return uniqBy(newArr.reverse(), field).reverse();
  }

  return [];
};

export const uppercaseString = (string = '') => {
  return isString(string) ? string.toUpperCase() : '';
};

export const removeItem = (arr, value) => {
  const index = arr.indexOf(value);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
};

export const getRowInTable = (propsCell = {}) => {
  if (isObject(propsCell) && propsCell?.row?.original) {
    return propsCell?.row?.original || {};
  }

  if (isObject(propsCell) && propsCell?.original) {
    return propsCell?.original || {};
  }

  return {};
};

export const checkHistoryRunning = (history) => {
  return toString(history?.status).toLowerCase().includes(statusHistoryEnum.running);
};

export const switchColorsStats = (cellName = '') => {
  switch (cellName) {
    case enumColumn.sent:
      return colorStatusReport.sent;

    case enumColumn.delivered:
      return colorStatusReport.delivered;

    case enumColumn.callbackCount:
    case enumColumn.clicked:
    case enumColumn.convertor:
    case enumColumn.listenCounter:
    case 'listen':
    case 'callback':
      // In general BE return callbackCount, but inside each item BE return callback
      return colorStatusReport.clicked;

    case enumColumn.replied:
      return colorStatusReport.replied;

    case enumColumn.failed:
      return colorStatusReport.failed;

    case enumColumn.optout:
      return colorStatusReport.optout;

    case enumColumn.blocked:
      return colorStatusReport.block;

    case enumColumn.attemptFailed:
      return colorStatusReport.block;

    default:
      return '';
  }
};

export const insert = (arr, index, ...newItems) => [
  // part of the array before the specified index
  ...arr.slice(0, index),
  // inserted items
  ...newItems,
  // part of the array after the specified index
  ...arr.slice(index),
];
export const checkHasMoreItem = (resDataLength, limit) => {
  return resDataLength.length >= limit;
};

export const isStaging = ['stg.textback.ai', 'stgadmin.textback.ai'].includes(
  window?.location?.hostname || '',
);

const stgLink = 'stgadmin.textback.ai';
const betaLink = 'beta.textback.ai';
const dashboardLink = 'admin.textback.ai';

export const isDevelopment =
  process.env.NODE_ENV !== 'production' ||
  ![betaLink, dashboardLink].includes(window?.location?.hostname || '');

export const isLocalhost = ['localhost'].includes(window?.location?.hostname || '');
export const isStgEnv = stgLink.includes(window?.location?.hostname || '');
export const isBetaEnv = betaLink.includes(window?.location?.hostname || '');
export const isProdEnv = dashboardLink.includes(window?.location?.hostname || '');

//! Table helpers
export const convertSelectedRowIdsToArray = (selectedRowIds) => {
  //* This function will work with getRowId props of TableCommon
  if (isObject(selectedRowIds)) {
    return Object.entries(selectedRowIds).map(([key, value]) => {
      return {
        key,
        value,
      };
    });
  }

  return [];
};

const extractSelectedRowIds = (ids) => {
  return ids.reduce((row, id) => ({ ...row, [id]: true }), {});
};

export const stateReducer = (ids) => (newState, action) => {
  if (action.type === 'toggleAllRowsSelected') {
    // determine if the header checkbox is selected or deselected
    // if selected then push all ids into selectedRowIds
    if (action.value) {
      return {
        ...newState,
        selectedRowIds: extractSelectedRowIds(ids),
      };
    }
    // else empty selectedRowIds state
    return { ...newState, selectedRowIds: {} };
  }
  return newState;
};

export const genExpanderTableCol = () => {
  return {
    id: 'expander',
    Header: '',
    // Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
    //   <span {...getToggleAllRowsExpandedProps()}>
    //     {isAllRowsExpanded ? (
    //       <CommonIcons.Expand size={SIZE_ICON} />
    //     ) : (
    //       <CommonIcons.Collapse size={SIZE_ICON} />
    //     )}
    //   </span>
    // ),
    Cell: ({ row }) => (
      <span {...row.getToggleRowExpandedProps()}>
        {row.isExpanded ? (
          <CommonIcons.Expand size={SIZE_ICON} />
        ) : (
          <CommonIcons.Collapse size={SIZE_ICON} />
        )}
      </span>
    ),
  };
};

export const convertKYCImgToBase64 = (src = '') => {
  if (isString(src)) {
    return `data:image/png;base64,${src}`;
  }

  console.error('Img src KYC must be string type!');
};

export const sleep = (ms) =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve('');
    }, ms);
  });

export const isNegativeNumber = (value) => {
  if (isNumeric(value)) {
    return value < 0;
  }

  return false;
};

export const saveFile = (blob, filename) => {
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  }
};

export const exportCSV = (data = [], name = '') => {
  if (isArray(data)) {
    let csvContent = 'data:text/csv;charset=utf-8,';

    (data || []).forEach(function (rowArray) {
      //* Handle comma each col
      const newRowArray = rowArray.map((el) => {
        if (el.includes(',') || el.startsWith('+')) {
          return `\"${el}\"`;
        }

        return el;
      });

      let row = newRowArray.join(',');
      csvContent += row + '\r\n';
    });

    let encodedUri = encodeURI(csvContent);
    let link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', name + '.csv');
    document.body.appendChild(link); // Required for FF

    link.click();
    link.remove();
  }

  if (isString(data)) {
    let encodedUri = encodeURI(`data:text/csv;charset=utf-8, ${data}`);
    let link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', name + '.csv');
    document.body.appendChild(link); // Required for FF

    link.click();
    link.remove();
  }
};

export const isNumeric = (n) => {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

export const checkCountryMatchWithConditions = (countries, selectedRoute, routeList) => {
  const route = routeList.find((route) => route.id === selectedRoute);
  if (!route) return [];

  return countries.filter((elm) => {
    return route.details.map((elm) => elm.country).includes(elm.iso);
  });
};

export const CheckCountryInMigrateDID = (countries = [], targetGroup = [], targetId = '') => {
  const target = targetGroup.find((elm) => elm.id === targetId);

  if (!target) return false;

  return countries.filter((elm) => target.countries.includes(elm.iso));
};

export const parseBase64ToFile = (base64, fileType) => {
  return `data:${fileType};base64,` + base64;
};

export const groupByField = (data = [], keyField = [], fieldToCalculate = []) => {
  if (!isArray(data) || !isArray(keyField) || !isArray(fieldToCalculate)) return [];
  const map = new Map();
  data.forEach((item) => {
    const key = keyField.map((field) => item[field]).join('_');

    if (!map.has(key)) {
      map.set(key, item);
    } else {
      const exist = map.get(key);
      fieldToCalculate.forEach((elm) => {
        const field = elm.trim();
        if (!exist[field] && !item[field]) {
          exist[field] = 0;
        } else if (!exist[field] && item[field]) {
          exist[field] = item[field];
        } else exist[field] += item[field];
      });
      map.set(key, exist);
    }
  });

  return [...map.values()];
};

export const isDefineValueOr = (value, valueException = undefined) => {
  if (
    isNumber(value) ||
    isObject(value) ||
    isArray(value) ||
    isBoolean(value) ||
    (isString(value) && value !== '')
  ) {
    return value;
  }

  return valueException;
};

export const replaceLinktoATag = (text = '') => {
  if (!isString(text)) return text;

  return text.replace(LINK_REGEX, (url) => {
    return `<a href="${url}"  target="_blank">${url}</a>`;
  });
};

export const convertToValueLabelOption = (data = [], valueField = '', labelField = '') => {
  if (!isArray(data) || !isString(valueField) || !isString(labelField)) return [];
  return data.map((elm) => {
    return {
      value: elm?.[valueField] || '',
      label: elm?.[labelField] || '',
    };
  });
};

export const parseReasonFailureAPITest = (jsonString = '') => {
  if (!isString(jsonString)) return '';

  try {
    let nextString = jsonString;
    const stringArr = nextString.split(' : ');
    if (!stringArr[1]) return '';
    stringArr[1] = stringArr[1].replace(/"/g, (value, index) => {
      if (index === 0 || index === stringArr[1].length - 1) {
        return '';
      }
      return value;
    });
    return JSON.parse(stringArr[1]);
  } catch (error) {
    console.log('error', error);
  }
  return {};
};

export const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);

    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };

    reader.onerror = () => {
      reject('Unable to read the Blob as a data URL');
    };
  });
};

export const parseUrltoFile = async (url, filename, mimeType) => {
  return fetch(url)
    .then(function (res) {
      return res.arrayBuffer();
    })
    .then(function (buf) {
      return new File([buf], filename, { type: mimeType });
    });
};

export const getSizeImage = async (src) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = function () {
      resolve({ width: this.width, height: this.height });
    };
    img.src = src;
  });
};

export const filterData = (data, containerWidth, maxWidth) => {
  const cloneData = cloneDeep(data);

  const maxElmPerRow = Math.floor(containerWidth / maxWidth);

  for (let index = 0; index < cloneData.length; index++) {
    const ratio = cloneData[index].width / cloneData[index].height;
    cloneData[index].translateX = (index % maxElmPerRow) * maxWidth;
    cloneData[index].translateY =
      index >= maxElmPerRow
        ? cloneData[index - maxElmPerRow].translateY + cloneData[index - maxElmPerRow].height
        : 0;
    cloneData[index].width = maxWidth;
    cloneData[index].height = maxWidth / ratio;
  }

  return cloneData;
};

export const convertToBase64 = (file, cb) => {
  const reader = new FileReader();

  reader.readAsDataURL(file);

  reader.onload = () => {
    cb(reader.result);
  };
};

export const isStringArray = (array) => {
  if (!isEmpty(array)) {
    return false;
  }

  return array.every((el) => isString(el));
};

export const omitObject = (object, keys = []) => {
  if (isObject(object)) {
    const nextObject = cloneDeep(object);

    keys.forEach((key) => {
      delete nextObject[key];
    });

    return nextObject;
  }

  return null;
};

export const sortByAlphabet = (array, key) => {
  if (!!key) {
    return cloneDeep(array).sort(function (a, b) {
      if (a[key] < b[key]) {
        return -1;
      }
      if (a[key] > b[key]) {
        return 1;
      }
      return 0;
    });
  }

  return cloneDeep(array).sort();
};

export const checkIsVideoFile = (typeFile) => {
  return isString(typeFile) && typeFile.includes('video/');
};

export const file2Base64 = (file) => {
  if (isString(file)) {
    return file;
  }

  return window.URL.createObjectURL(file);
};

/**
 * @param {string} string
 */
export const getBase64FromImageTag = (string) => {
  if (!isString(string)) {
    return null;
  }

  const regex = /src="data:image\/[^"]+base64,([^"]+)"/;
  const match = string.match(regex);

  if (match) {
    const base64Data = match[1];
    return base64Data;
  }

  return null;
};

/**
 * @param {string} string
 */
export const replaceSrcInImageTag = (string, newValue) => {
  if (isString(string)) {
    string = string.replace(/<img[^>]*src="data:[^"]*"[^>]*>/, newValue);
    return string;
  }

  return null;
};

/**
 * @param {string} base64Data
 */
export const base64ToBlob = (base64Data, type) => {
  // Decode the base64 data
  const binaryData = atob(base64Data);

  // Create a Uint8Array from the binary data
  const array = new Uint8Array(binaryData.length);
  for (let i = 0; i < binaryData.length; i++) {
    array[i] = binaryData.charCodeAt(i);
  }

  // Create a Blob from the Uint8Array
  const blob = new Blob([array], { type: type || 'image/png' }); // You may need to specify the appropriate MIME type
  return blob;
};

export const isReactComponent = (element) => {
  return React.isValidElement(element);
};

export const trimAllValuesInObject = (obj) => {
  if (isString(obj)) {
    return obj.trim();
  }

  if (isArray(obj)) {
    return obj.map((item) => trimAllValuesInObject(item));
  }

  if (isPlainObject(obj) && obj !== null) {
    const trimmedObj = {};
    for (const key in obj) {
      trimmedObj[key] = trimAllValuesInObject(obj[key]);
    }
    return trimmedObj;
  }

  return obj;
};

export const genBgColorPackage = (type) => {
  const bg = {
    BASIC: 'bg-color-primary-v2',
    PRO: 'bg-color-warning-v2',
    ENTERPRISE: 'bg-color-success-v2',
    CUSTOM: 'bg-color-black',
  };

  return bg?.[type] || '';
};

export const genColorTextPackage = (type) => {
  const color = {
    BASIC: 'color-white',
    PRO: 'color-black',
    ENTERPRISE: 'color-white',
    CUSTOM: 'color-white',
  };

  return color?.[type] || '';
};

export const checkResponseMsgErr = (response) => {
  if (isString(response?.data) && !!response?.data) {
    return response?.data;
  }

  return null;
};

export const clearAllTimeout = () => {
  let l = 1000;

  while (l >= 0) {
    clearTimeout(l);
    l = l - 1;
  }
};

export const genLinkMediaPublic = ({ userId, fixName }) => {
  if (isLocalhost || isStaging) {
    return `http://34.120.171.189/public/voice/stream_by_name/${userId}/${fixName}`;
  }
  return `https://callback.textback.ai/public/voice/stream_by_name/${userId}/${fixName}`;
};

export const handleBodyRequestCommon = (arg) => {
  if (arg instanceof FormData) {
    return arg;
  }

  if (isPlainObject(arg)) {
    return trimAllValuesInObject(cloneDeep(arg));
  }

  if (isString(arg)) {
    return arg.trim();
  }

  return arg;
};

//* { A: 1 } -> { 1: A }
export const switchLabelValueObject = (obj) => {
  if (isPlainObject(obj)) {
    let tempObj = {};
    Object.entries(obj).forEach(([key, value]) => {
      tempObj[value] = key;
    });

    return tempObj;
  }

  return {};
};

export const checkLinkHttps = (link = '') => {
  if (isString(link)) {
    return link.includes('https') || link.includes('http');
  }

  return false;
};

export const isStringHasHTMLTags = (string = '') => {
  if (isString(string)) {
    return /<\/?[a-z][\s\S]*>/g.test(string);
  }

  return false;
};

//* Change key is value and value is key in Object
export const switchKeyToValues = (obj) => {
  if (isPlainObject(obj)) {
    return Object.entries(obj).reduce((nextObj, el) => {
      const [key, value] = el;

      nextObj[value] = key;

      return nextObj;
    }, {});
  }

  return {};
};

export const checkIs404 = (error) => {
  return isString(error) && error.includes('404');
};

export const DivElement = React.memo(({ children, ...rest }) => {
  return <div {...rest}>{children}</div>;
});

export function findParentBySelector(elm, selector) {
  function collectionHas(a, b) {
    //* helper function (see below)
    for (let i = 0, len = a.length; i < len; i++) {
      if (a[i] == b) return true;
    }
    return false;
  }

  let all = document.querySelectorAll(selector);
  let cur = elm.parentNode;
  while (cur && !collectionHas(all, cur)) {
    //* keep going up until you find a match
    cur = cur.parentNode; //go up
  }
  //* will return null if not found
  return cur;
}

export const detectBrowserHidden = () => {
  let hidden;
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
  }
  return {
    isHidden: document[hidden],
  };
};

export const findCountriesByCountriesCode = (countriesCode = []) => {
  if (!isArray(countriesCode)) {
    return [];
  }

  return countriesCode
    .map((code) => {
      const found = listCountries?.find((el) => el.code === code);
      if (found) {
        return {
          ...found,
          label: `${found.name} (${found.code})`,
          value: found?.code,
        };
      }

      return '';
    })
    .filter((el) => !!el);
};

export const onTextAreaEnter = (callback) => (e) => {
  if (e.key === 'Enter' && !e.shiftKey) {
    e.preventDefault();
    callback && callback();
  }
};

/**
 *
 * @param {'modal'} mode
 * @returns
 */
export const menuPortalTargetSelect = (mode = '') => {
  if (mode === 'modal') {
    return document.querySelectorAll('.modal').length > 1
      ? document.querySelectorAll('.modal')[document.querySelectorAll('.modal').length - 1]
      : document.querySelectorAll('.modal')?.[0] || undefined;
  }

  return undefined;
};

export const getCountryName = (countryCode) => {
  return listCountries.find((elm) => elm.code === countryCode)?.name || '';
};

export function isArrayIncludeObject(array, objectCompare) {
  return (array || []).some((el) => isEqual(el, objectCompare));
}

export const showCost = (value, numberDecimal) => {
  if (!isNumeric(value)) {
    return null;
  }

  if (!value) {
    return 0;
  }

  return localeNumber(Number(value).toFixed(numberDecimal || 2));
};

export const convertCountryListToSelectOptions = (list) => {
  return list.map((el) => ({
    label: el.name,
    value: el.code,
  }));
};

export const orderLayoutAByB = (
  layoutA,
  layoutB,
  { fieldKey = 'accessor', fieldKeyB = 'accessor' } = {},
) => {
  let pointer = 0;
  const layoutAKeys = layoutA.map((el) => get(el, fieldKey)).filter((el) => !!el);
  const keysOrdered = layoutB
    .map((el) => get(el, fieldKeyB))
    .filter((el) => !!el && layoutAKeys.includes(el));

  const result = layoutAKeys.map((k) => {
    if (!keysOrdered.includes(k)) {
      return k;
    }

    return keysOrdered[pointer++];
  });

  return result.map((field) => {
    const layoutBFound = layoutB?.find((el) => get(el, fieldKeyB) === field);
    const layoutAFound = layoutA?.find((el) => get(el, fieldKey) === field);
    return {
      ...layoutAFound,
      ...layoutBFound,
      type: layoutBFound?.[fieldKeyB] || layoutAFound?.[fieldKey],
    };
  });
};

export const isInsideModal = (element) => {
  if (!element) return false;

  const modalElements = document.querySelectorAll('.modal-dialog');
  if (modalElements.length > 0) {
    for (let i = 0; i < modalElements.length; i++) {
      if (modalElements[i].contains(element)) {
        return true;
      }
    }

    return false;
  }
};

export function isReactFragment(variableToInspect) {
  if (variableToInspect.type) {
    return variableToInspect.type === React.Fragment;
  }
  return variableToInspect === React.Fragment;
}
